<div class="contenedor">
    <h2 class="titulo-principal">Repositorio Digital del Instituto Sudamericano</h2>
    <div class="caja-contenido">
        <h3 class="subtitulo">Repositorio Digital del Instituto Sudamericano</h3>
        <p>Bienvenidos a nuestro Repositorio, donde se publican los resultados de los proyectos y las tesis de titulación de nuestros estudiantes.</p>
        <p>En el Instituto Sudamericano, cada estudiante es un universo de posibilidades, donde el conocimiento no es un destino, sino un viaje continuo de transformación personal y profesional.</p>
    </div>
</div>


